<router-outlet></router-outlet>
<app-aetnafooter></app-aetnafooter>
<i class="pi pi-check" style="color: #f5f5f5;"></i>
